// extracted by mini-css-extract-plugin
module.exports = {"svg":"IconArrowUpAndDown_svg__f7gIH","path":"IconArrowUpAndDown_path__wKdar"};